export const PRODUCT_NATURE_TYPES = {
  product: 1,
  accessory: 2,
  sparePart: 3,
  service: 4,
} as const;
